module.exports = __webpack_public_path__ + "media/images/icons/icon-pinterest-9ca3c91258c5c1bce5fe117790641c52.svg";